import { useContext, useEffect, useState } from 'react';
import STORE from '../../../../store';
import AccountPickerContext from '../../../../contexts/AccountPickerContext';
import fiscalPeriodTypeCheckers from './fiscalPeriodTypeCheckers';

const useFiscalYears = () => {
  const { selectedAccountId } = useContext(AccountPickerContext);
  const [fiscalYears, setFiscalYears] = useState<FixedPeriods.FiscalYear[]>([]);

  useEffect(() => {
    STORE.fixedPeriods
      .getFixedPeriodIntervalsRef({
        fixedPeriodId: 'fiscalYears',
        accountId: selectedAccountId,
      })
      .onSnapshot((docs) => {
        const newFiscalYears: FixedPeriods.FiscalYear[] = [];
        docs.forEach((doc) => {
          const period = doc.data();
          if (fiscalPeriodTypeCheckers.isFiscalYear(period)) {
            newFiscalYears.push(period);
          }
        });
        setFiscalYears(newFiscalYears);
      });
  }, [selectedAccountId]);

  return { fiscalYears };
};

export default useFiscalYears;
